function getExtension(a){
    return a.split('.').pop()
}

export default getExtension